export default __webpack_public_path__ + "static/media/key-step6.24accba3.gif";